var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMypage = function SvgMypage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 3,
    stroke: "#191919",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18c0-.522.449-1.263 1.79-1.934C8.072 15.426 9.912 15 12 15s3.928.425 5.21 1.066C18.55 16.736 19 17.478 19 18v1H5v-1Zm16 0c0-1.687-1.342-2.946-2.896-3.723C16.49 13.47 14.331 13 12 13c-2.33 0-4.49.47-6.104 1.277C4.342 15.054 3 16.313 3 18v3h18v-3Z",
    fill: "#191919"
  })));
};

export default SvgMypage;